import React, { Component } from "react";
import FirstPage from "./FirstPage";
import { Success } from "./Success";

import "../styles/main.css";

import { parsePhoneNumberFromString as format } from "libphonenumber-js";

let search = window.location.search;
let params = new URLSearchParams(search);
let successParam = params.get("success");

export class Jsl extends Component {
  state = {
    step: successParam ? 1 : 0,
    fullName: "",
    phoneNumber: "",
    validPhoneNumber: "",
    city: "",
    schoolInput: "",
    validSchool: "",
    success: successParam,
    classValues: ["יא׳", "יב׳"],
    classSubValues: [],
    classSelection: "",
    classSubSelection: "",
    language: "",
    invalidPhone: false,
    invalidSchoolname: false,
  };

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
    });
  };

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  /***** Jsl application ******/

  // First page FULL NAME
  handleChangeName = async (e) => {
    await this.setState({ fullName: e.target.value });
  };

  // First page PHONE NUMBER
  handleChangePhoneNumber = async (e) => {
    const userPhoneInput = e.target.value;
    await this.setState({
      phoneNumber: userPhoneInput,
    });

    const formattedPhone = format(userPhoneInput, "IL");
    if (formattedPhone) {
      if (formattedPhone.isValid()) {
        await this.setState({
          validPhoneNumber: formattedPhone.number,
          invalidPhone: false,
        });
      } else {
        await this.setState({
          invalidPhone: true,
        });
      }
    } else {
      await this.setState({
        invalidPhone: true,
      });
    }
  };

  // First page city
  handleChangeCity = async (e) => {
    await this.setState({
      city: e.target.value,
    });
  };

  // First page school
  handleSchool = async (e) => {
    console.log(e.target.value);
    await this.setState({
      schoolInput: e.target.value,
    });
    if (
      this.state.schoolInput.length > 2 &&
      this.state.schoolInput.length < 31
    ) {
      await this.setState({
        validSchool: this.state.schoolInput,
        invalidSchoolname: false,
      });
    } else {
      await this.setState({
        invalidSchoolname: true,
      });
    }
  };

  // Class select dropdown
  handleChangeClassValues = async (e) => {
    console.log(e.target.value);
    await this.setState({
      classSelection: e.target.value,
    });

    await this.setSubListValues(this.state.classSelection);
  };

  // sets the sublist values
  setSubListValues = async (value) => {
    let subListDropdown;
    switch (value) {
      case "יא׳":
      case "יב׳":
        subListDropdown = [
          "3 יחידות שאלון 182 (801)",
          "3 יחידות שאלון 381 (802)",
          "3 יחידות שאלון 382 (803)",
          "4 יחידות שאלון 481 (804)",
          "4 יחידות שאלון 482 (805)",
          "5 יחידות שאלון 581 (806)",
          "5 יחידות שאלון 582 (807)",
        ];
        break;
      default:
        break;
    }
    await this.setState({
      classSubValues: subListDropdown,
    });
  };

  // class sublist second dropdown
  handleChangeSubClassValues = async (e) => {
    await this.setState({
      classSubSelection: e.target.value,
    });
  };

  // handle radio language
  handleChangeLanguage = async (e) => {
    await this.setState({
      language: e.target.value,
    });
  };

  /***** End Jsl application ******/

  // finish step where all data is sent to an API
  finish = async () => {
    let allValues;
    // To retrive that item
    try {
      console.log("1");
      const serializedState = localStorage.getItem("state");
      console.log("2");

      if (serializedState === null) {
        console.log("3");
        return undefined;
      }
      allValues = JSON.parse(serializedState);
    } catch (err) {
      console.log("4");
      allValues = undefined;
    }
    console.log("5");
    const {
      fullName,
      validPhoneNumber,
      city,
      validSchool,
      classSelection,
      classSubSelection,
      language,
    } = allValues;
    //send request to API with all the values in an object

    const Http = new XMLHttpRequest();
    const url = `https://script.google.com/macros/s/AKfycbxP0MGnJnBne2qTuJ9DwL7JT2OgDwJp77HWRwjBBYilEYR_mpYg/exec?fullName=${fullName}&userMobile=${validPhoneNumber}&city=${city}&school=${validSchool}&grade=${classSelection}&gradeLevel=${classSubSelection}&language=${language}`;
    console.log(url)
    Http.addEventListener("load", () => {
      // update the state of the component with the result here
      console.log(Http.responseText);
    });
    Http.open("GET", url);
    Http.send();
  };

  cancel = () => {
    this.setState({
      step: 0,
      fullName: "",
      validPhoneNumber: "",
      city: "",
      validSchool: "",
      classSelection: "",
      classSubSelection: "",
      language: "",
    });
  };

  saveToLocalStorage = () => {
    const {
      fullName,
      validPhoneNumber,
      city,
      validSchool,
      classSelection,
      classSubSelection,
      language,
    } = this.state;
    const allValues = {
      fullName,
      validPhoneNumber,
      city,
      validSchool,
      classSelection,
      classSubSelection,
      language,
    };
    // To save the item
    try {
      const serializedState = JSON.stringify(allValues);
      localStorage.setItem("state", serializedState);
    } catch (err) {
      return undefined;
    }
  };

  // ------------ do tuka site trebaat

  render() {
    const { step } = this.state;
    const {
      fullName,
      phoneNumber,
      validPhoneNumber,
      city,
      school,
      validSchool,
      classSelection,
      classSubSelection,
      language,
    } = this.state;
    const values = {
      fullName,
      phoneNumber,
      validPhoneNumber,
      city,
      school,
      validSchool,
      classSelection,
      classSubSelection,
      language,
    };

    let mainContent = null;

    switch (step) {
      case 0:
        mainContent = (
          <FirstPage
            nextStep={this.nextStep}
            handleChangeName={this.handleChangeName}
            handleChangePhoneNumber={this.handleChangePhoneNumber}
            handleChangeCity={this.handleChangeCity}
            handleSchool={this.handleSchool}
            classValues={this.state.classValues}
            handleChangeClassValues={this.handleChangeClassValues}
            classSubValues={this.state.classSubValues}
            handleChangeSubClassValues={this.handleChangeSubClassValues}
            handleChangeLanguage={this.handleChangeLanguage}
            values={values}
            cancel={this.cancel}
            currStep={this.state.step}
            validPhoneNumber={this.state.validPhoneNumber}
            invalidPhone={this.state.invalidPhone}
            invalidSchoolname={this.state.invalidSchoolname}
            saveToLocalStorage={this.saveToLocalStorage}
            finish={this.finish}
          />
        );
        break;

      case 1:
        mainContent = <Success finish={this.finish} />;
        break;

      default:
        console.log("Invalid step", step);
        break;
    }
    return (
      <div className="main">
        {step <= 2 ? (
          <div className="image">
            <img
              src={require("../assets/all-logo.png")}
              alt="logo"
              width="220"
              height="46"
            />
            <p className="logo-text">ככה לומדים היום מהבית</p>
          </div>
        ) : null}
        {mainContent}
        {/* <p className="contact-text-bottom" variant="caption" display="block">
          לכל שאלה, בעיה אנחנו כאן
          <br />
          טלפון: <a href={"tel:052-8808558"}>052-8808558</a> מייל:{" "}
          <a href={"mailto:contact@class.me"}>contact@class.me</a>
          <a class="terms" href={"https://class.me/terms-schools.html"}>
            תנאי שימוש
          </a>
        </p> */}
        <p></p>
      </div>
    );
  }
}

export default Jsl;
